import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.js";
import { TelegramSdkRoot } from "./components/TelegramSdkRoot.js";
import { clearMiniAppStoreUiCache } from "./lib/store-cache-reset.js";
import { clearObsoleteCustomerServiceWorkerOnce } from "./lib/clear-obsolete-customer-sw.js";
import "./index.css";

clearObsoleteCustomerServiceWorkerOnce();

// FUNCTIONALITY-097 — nuclear WebView reset: clear UI caches when ?reset=1
try {
  const params = new URLSearchParams(window.location.search);
  if (params.get("reset") === "1") {
    clearMiniAppStoreUiCache();
    const onceKey = `asiastyle.reset.cleared.${params.get("build") ?? "unknown"}`;
    if (sessionStorage.getItem(onceKey) !== "1") {
      sessionStorage.setItem(onceKey, "1");
    }
  }
} catch {
  /* ignore */
}

const root = document.getElementById("root");
if (!root) throw new Error("Root element not found");

createRoot(root).render(
  <StrictMode>
    <TelegramSdkRoot>
      <App />
    </TelegramSdkRoot>
  </StrictMode>,
);
